// extracted by mini-css-extract-plugin
export default {"contentSection":"mobile-layout_contentSection__hmgFm","noBottomMargin":"mobile-layout_noBottomMargin__vF511"};